import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @component Tooltip
 * @props (see propTypes)
 */
const Tooltip = ({
    id,
    className,
    currencyTooltip,
    depositTooltip,
    icon = 'i',
    children
}) => {

    return (
        <div className={`tooltip ${depositTooltip || currencyTooltip ? 'ml0' : 'ml4'} cursor-pointer ${className ? className : ''}`}>
            <div
                className='type-style-3 border border-radius-100px flex justify-center items-center'
                style={{width: '2.6rem', height: '2.6rem', fontSize: '1.7rem', lineHeight:'19.3px'}}>{icon}</div>

            <div
                className='tooltip__content'
                id={id}>
                <div className='tooltip__content-inner'>
                    {children}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

Tooltip.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    className: PropTypes.string,
    currencyTooltip: PropTypes.bool,
    depositTooltip: PropTypes.bool,
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.array
    ]),
    id: PropTypes.string.isRequired,
};

export default Tooltip;
